import dayjs from "dayjs";

export const normalizeDateValue = (v: any): string | null =>
  v ? dayjs(v).format("YYYY-MM-DD") : null;

export const toIso = (date: any): string => {
  if (!date) return '';

  if (typeof date === 'string') {
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }

    const parsed = new Date(date);
    if (!isNaN(parsed.getTime())) {
      return parsed.toISOString().split('T')[0];
    }

    return date;
  }

  if (date instanceof Date) {
    return date.toISOString().split('T')[0];
  }

  return String(date);
};

export const normalizeDate = (date: any): string | null => {
  if (date == null || date === '') {
    return null;
  }

  const iso = toIso(date);
  return iso || null;
};

export const toLocalDateString = (date: any): string | null => {
  if (date == null) {
    return null;
  }

  const iso = toIso(date);
  if (!iso) {
    return null;
  }

  const match = iso.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) {
    const d = new Date(iso);
    if (!isNaN(d.getTime())) {
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    return null;
  }

  return iso;
};